export default __webpack_public_path__ + "static/media/error.05294c9c.svg";